export const defaultStateBudgetState = {
	StateBudgets: [],
	StateBudgetsLoaded: false,
	Total: 0
};

export default {
	...defaultStateBudgetState
};
